import { call, put, takeLatest } from 'redux-saga/effects';
import {
  addMeasurementAction,
  addMeasurementFailedAction,
  addMeasurementSuccessAction,
  getScreenListAction,
  getScreenListFailedAction,
  getScreenListSuccessAction,
  getMissingScreenListAction,
  getMissingScreenListSuccessAction,
  getMissingScreenListFailedAction,
  validateScreenListAction,
  validateScreenListFailedAction,
  validateScreenListSuccessAction,
  downloadMissingScreenListSuccessAction,
  downloadMissingScreenListFailedAction,
  downloadMissingScreenListAction,
} from './AddMeasurement.slice';
import {
  getScreenList,
  uploadScreenList,
  validateScreenList,
  getMissingScreenList,
  downloadMissingScreenList,
} from './AddMeasurement.service';

function* uploadScreenListSaga(action) {
  try {
    const { pixelId, data } = action.payload;
    const params = {
      pixelId,
    };
    const response = yield call(uploadScreenList, data, params);
    yield put(addMeasurementSuccessAction(response));
  } catch (error) {
    yield put(addMeasurementFailedAction(error));
  }
}

function* validateScreenListSaga(action) {
  try {
    const { campaignId, data, pixelId } = action.payload;
    const params = {
      campaignId,
      pixelId,
    };
    const response = yield call(validateScreenList, data, params);
    yield put(validateScreenListSuccessAction(response));
  } catch (error) {
    yield put(validateScreenListFailedAction(error));
  }
}

function* getScreenListSaga(action) {
  try {
    const response = yield call(getScreenList, action.payload);
    yield put(getScreenListSuccessAction(response));
  } catch (error) {
    yield put(getScreenListFailedAction(error));
  }
}
function* getMissingScreenListSaga(action) {
  try {
    const response = yield call(getMissingScreenList, action.payload);
    yield put(getMissingScreenListSuccessAction(response));
  } catch (error) {
    yield put(getMissingScreenListFailedAction(error));
  }
}

function* downloadMissingScreenListSaga(action) {
  try {
    const response = yield call(downloadMissingScreenList, action.payload);
    yield put(downloadMissingScreenListSuccessAction(response));
  } catch (error) {
    yield put(downloadMissingScreenListFailedAction(error));
  }
}

export default function* addMeasurementSaga() {
  yield takeLatest(addMeasurementAction.type, uploadScreenListSaga);
  yield takeLatest(validateScreenListAction.type, validateScreenListSaga);
  yield takeLatest(getScreenListAction.type, getScreenListSaga);
  yield takeLatest(getMissingScreenListAction.type, getMissingScreenListSaga);
  yield takeLatest(
    downloadMissingScreenListAction.type,
    downloadMissingScreenListSaga
  );
}
